import { updateUserConfiguration } from 'owa-options-core';
import FocusedInboxOptionState from '../store/schema/FocusedInboxOptionState';
import store from '../store/store';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import setIsFocusedInboxCapableService from '../services/setIsFocusedCapableService';
import { logUsage } from 'owa-analytics';

export type SaveFocusInboxOptionStitchName = 'saveFocusInboxOptionStitchName';
export type SaveFocusedInboxOptionStitch = (isFocusedInboxEnabled: boolean) => void;

const saveFocusInboxOptionStitchName: SaveFocusInboxOptionStitchName =
    'saveFocusInboxOptionStitchName';

export interface SaveFocusedInboxOptionState {
    optionState: FocusedInboxOptionState;
    userOptions: UserOptionsType;
}

let saveFocusedInboxOption = select<SaveFocusedInboxOptionState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(
    action('saveFocusedInboxOption')(async function saveFocusedInboxOption(
        isEnabledOverride?: boolean,
        state?: SaveFocusedInboxOptionState
    ) {
        let { optionState, userOptions } = state;

        if (isEnabledOverride !== undefined) {
            optionState.isEnabled = isEnabledOverride;
        }

        userOptions.IsFocusedInboxEnabled = optionState.isEnabled;

        // Raise stitch so that, if we're running in mail, the focused inbox will toggle on and off
        raiseAction<SaveFocusedInboxOptionStitch>(saveFocusInboxOptionStitchName)(
            userOptions.IsFocusedInboxEnabled
        );

        let servicePromises: Promise<any>[] = [];

        servicePromises.push(
            updateUserConfiguration([
                {
                    propertyName: 'IsFocusedInboxEnabled',
                    propertyType: 'Boolean',
                    propertyValue: `${optionState.isEnabled}`,
                },
            ])
        );

        // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
        if (userOptions.IsFocusedInboxEnabled) {
            servicePromises.push(setIsFocusedInboxCapableService());
        }

        await Promise.all(servicePromises);
    })
);

export default saveFocusedInboxOption;

const OPTION_QUICK_SETTING_USAGE_KEY = 'QuickSettingFocusedInbox';

export function saveFocusedInboxQuickOption(isEnabled: boolean) {
    logUsage(OPTION_QUICK_SETTING_USAGE_KEY, [`${isEnabled}`]);
    saveFocusedInboxOption(isEnabled);
}
